import Chart from 'chart.js/auto';
window.application.register("pie-chart", 
	class extends Stimulus.Controller {
		static get targets() {
		  return [ "canvas"]
		}

		connect(){
			this.element[this.identifier] = this;
			this.dataset = [];


			// var a = JSON.parse(this.data.get('dataset'));
			//only show data after 2016
			// var b = a.map(data => {
			// 	return {
			// 		x: moment(data.date, 'YYYY-MM-DD').valueOf(),
			// 		y: parseFloat(data.price)
			// 	}
			// });
			this.dataset = JSON.parse(this.data.get('dataset'));
			// console.log(this.dataset)
			this.render();
		}

		render(){
			
			if(this.chart){
				// this.chart.data.labels = [dataset[0].x, dataset[dataset.length-1].x];
				// this.chart.data.datasets[0].data = dataset;
				// this.chart.update();
			}else{
				var labels = [];
				var dataset = [];
				var colors = [];
				for(let key in this.dataset){
					if(!this.dataset[key].indented && this.dataset[key].value && parseFloat(this.dataset[key].value)>0){
						labels.push(key);
						dataset.push(parseFloat(this.dataset[key].pieValue));
						colors.push(this.dataset[key].color);
					}
				}
				this.chart = new Chart(this.canvasTarget.getContext('2d'), {
		    		type: 'doughnut',
		    		// clip: 30,
		    		// radius: '20%',
		    		// cutout:'',
					data: {
						labels: labels,
						datasets: [{
							data: dataset,
							backgroundColor: colors,
							borderColor: colors,
							hoverBorderColor: colors,
							hoverBackgroundColor: colors,
							// hoverOffset: 4
						}]
					    // datasets: [{
					    // 	borderColor: '#E87722',
					    // 	pointBackgroundColor:'#E87722',
					    // 	pointRadius: 2,
					    // 	borderWidth: 1,
					    //     data: dataset
					    // }]
					},
					options: {
						cutout: '20%',
						responsive: true,
						maintainAspectRatio: false,
						// aspectRatio: 1,
						plugins:{
							legend: {
								display: false,
							},
							tooltip:{
								callbacks:{
									label: function(tooltipItem) {
				                        return tooltipItem.label + ' - ' + tooltipItem.formattedValue + ' %'
				                    }
								}
							}
						},
					    animation:true
					}
				});
			}
		}

		disconnect(){
			try{this.tearDown()}catch(err){};
		}

		tearDown(){
			// this.element.innerHTML = '';
		}
	}
)